import { FC } from 'react'
import { ThunderboltOutlined } from '@ant-design/icons'
import { PageBreadcrumb } from '../components/PageBreadcrumb'
import { ChecksTypeTable } from '../components/ChecksTypeTable'
import { RNChecks } from '../helpers/routeNames'

const ACCENT = '#fa8c16'

export const ChecksElectric: FC = () => {
	return (
		<div style={{ paddingBottom: 90 }}>
			<PageBreadcrumb
				items={[
					{ label: 'Характеристики', path: RNChecks },
					{ label: 'Электрические' }
				]}
			/>

			{/* Hero header */}
			<div
				style={{
					background: `linear-gradient(135deg, ${ACCENT} 0%, #ffc53d 100%)`,
					borderRadius: 14,
					padding: '28px 24px',
					marginBottom: 24,
					display: 'flex',
					alignItems: 'center',
					gap: 20
				}}>
				<div
					style={{
						width: 56,
						height: 56,
						minWidth: 56,
						borderRadius: '50%',
						background: 'rgba(255,255,255,0.2)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}>
					<ThunderboltOutlined
						style={{ fontSize: 28, color: '#fff' }}
					/>
				</div>
				<div>
					<h1
						style={{
							color: '#fff',
							margin: 0,
							fontSize: 22,
							fontWeight: 700
						}}>
						Электрические характеристики
					</h1>
					<p
						style={{
							color: 'rgba(255,255,255,0.8)',
							margin: '4px 0 0',
							fontSize: 14
						}}>
						Просмотр, добавление и удаление электрических параметров
					</p>
				</div>
			</div>

			<ChecksTypeTable charType="electric" accentColor={ACCENT} />
		</div>
	)
}
